/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnercodetakenerror3Inputs */

const en_partnercodetakenerror3 = /** @type {(inputs: Partnercodetakenerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This code is already taken.`)
};

const de_partnercodetakenerror3 = /** @type {(inputs: Partnercodetakenerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Kürzel ist schon vergeben.`)
};

/**
* | output |
* | --- |
* | "This code is already taken." |
*
* @param {Partnercodetakenerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnercodetakenerror3 = /** @type {((inputs?: Partnercodetakenerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnercodetakenerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnercodetakenerror3(inputs)
	return de_partnercodetakenerror3(inputs)
});
export { partnercodetakenerror3 as "partnerCodeTakenError" }